/**
 * @generated SignedSource<<20de469b329caee01493c587eed1822c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastScreenAdminContent_StorecastScreen$data = {
  readonly defaultDashboard: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"InfoBox_StorecastScreen" | "StorecastScreenAdminModeSelector_StorecastScreen" | "StorecastScreenAdminSchedule_StorecastScreen">;
  readonly " $fragmentType": "StorecastScreenAdminContent_StorecastScreen";
};
export type StorecastScreenAdminContent_StorecastScreen$key = {
  readonly " $data"?: StorecastScreenAdminContent_StorecastScreen$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastScreenAdminContent_StorecastScreen">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastScreenAdminContent_StorecastScreen",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "defaultDashboard",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastScreenAdminModeSelector_StorecastScreen"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastScreenAdminSchedule_StorecastScreen"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InfoBox_StorecastScreen"
    }
  ],
  "type": "StorecastScreen",
  "abstractKey": null
};
})();

(node as any).hash = "88f6cc30c9adcd41b46a80d7d7d05a9a";

export default node;
